import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Skeleton,
  useBreakpointValue,
  useDisclosure
} from "@chakra-ui/react";
import { useContext } from "react";

import { Image as StrorybookImage } from "../../image/image";
import { Header } from "../header/header";
import { ContributionContext } from "../context";

export function Image() {
  const { variant, imageSrc, imageAlt, isLoaded, showImage, onClick } =
    useContext(ContributionContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useBreakpointValue({ base: true, lg: false }) || false;

  if (!showImage || !imageSrc) return null;

  const vertical = {
    width: "auto",
    height: "auto",
    minWidth: "auto",
    maxHeight: 265
  };
  const imageSize = {
    vertical,
    horizontal: isMobile
      ? vertical
      : { width: 288, height: "auto", minWidth: 288, maxHeight: 265 },
    elevated: { width: "full", height: 84, minWidth: "auto", maxHeight: 84 }
  };

  const width = imageSize[variant]?.width || "auto";
  const height = imageSize[variant]?.height || "auto";
  const minWidth = imageSize[variant]?.minWidth || "auto";
  const maxHeight = imageSize[variant]?.maxHeight || "auto";

  if (!isLoaded) {
    return <Skeleton minW={width} minH={maxHeight} />;
  }

  return (
    <>
      <StrorybookImage
        objectFit="cover"
        src={imageSrc}
        alt={imageAlt}
        w={width}
        h={height}
        minW={minWidth}
        maxH={maxHeight}
        borderRadius="none"
        _hover={{ opacity: 0.7 }}
        onClick={onClick ? undefined : onOpen}
        role={onClick ? "presentation" : undefined}
      />
      <Modal
        isOpen={isOpen}
        size={{ base: "full", lg: "xl" }}
        onClose={onClose}
        isCentered
      >
        <ModalOverlay bgColor="black" color="white" />
        <ModalContent bgColor="black" color="white">
          <ModalHeader
            p={3}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Header hideActionList />
            <ModalCloseButton position="static" />
          </ModalHeader>
          <ModalBody bgColor="black" color="white" p={4}>
            <StrorybookImage
              width="full"
              height="auto"
              maxHeight={456}
              marginLeft="auto"
              marginRight="auto"
              objectFit="contain"
              src={imageSrc}
              alt={imageAlt}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
